<button mat-flat-button class="control-button" (click)="toggle()">
    <mat-icon class="icon">{{isActive ? activeIcon : inactiveIcon}}</mat-icon>
    <div class="label">{{isActive ? activeLabel : inactiveLabel}}</div>
</button>